











import Vue, { PropType } from 'vue';

const defaultFormatter = (value: number) => `${Math.round(value*100)}%`;

export default Vue.extend({
  name: 'LoadingBar',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    displayValue: Boolean,
    formatValue: {
      type: Function as PropType<(value: number) => string>,
      default: defaultFormatter,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    doneText: {
      type: String,
      default: 'Done',
    },
  },
  computed: {
    isDone(): boolean {
      return this.value >= 1;
    },
    labelText(): string {
      if (this.isDone) {
        return this.doneText;
      }
      if (typeof this.formatValue !== 'function') {
        return defaultFormatter(this.value);
      }
      return this.formatValue(this.value);
    },
  },
});
